import styles from "../../css/coursedetails.module.css";

function ReactOutline() {
  return (
    <>
      <p>
        <strong>This Course is also available in this program:</strong>
      </p>
      <ul className={styles.learnStruct}>
        <li>Frontend Development</li>
      </ul>
    </>
  );
}

export default ReactOutline;
